<form class="call-sign-form">
  <div mat-dialog-content>
    <h3 mat-dialog-title>{{ 'common.selectYourCallSign' | t }}</h3>
    <sn-searchbar 
      (valueChange)="onSearchValueChanged($event)"
      [placeholder]="'common.search' | t">
    </sn-searchbar>
    <main class="p-sm">
      <sn-data-list #list [fetchFn]="loadData">
        <sn-infinite-scroll>
          <ng-template [ngIf]="list.dataSource?.data.length" [ngIfThen]="listTmpl"></ng-template>
        </sn-infinite-scroll>
      </sn-data-list>
    </main>
  </div>
  <mat-dialog-actions>
      <button mat-button color="danger" (click)="close()">{{ 'common.cancel' | t }}</button>
      <button mat-button color="success" (click)="onSubmit()" [disabled]="!callSign">{{ 'common.select' | t }}</button>
  </mat-dialog-actions>
</form>

<ng-template #listTmpl>
  <fs-team-list
    [selected]="callSign"
    [items]="list.dataSource.data"
    (itemTap)="onCallSignSelected($event)"
  >
  </fs-team-list>
</ng-template>
